@let splitTextValue = splitText();
<span>{{splitTextValue.firstPart}}</span>
<span class="d-inline-flex text-nowrap align-items-center">
    {{splitTextValue.lastWordPart}}
    <ng-content></ng-content>
</span>